var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"nav-list overflow-y-auto",attrs:{"dense":""}},[_vm._l((_vm.routes),function(route){return _c('nav-list-item',{key:route.name,attrs:{"item":route.meta,"link":route.path,"active":_vm.$route.name === route.name ||
        ('children' in route && route.children.some(el => el.name === _vm.$route.name)),"mode":"parent"}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }